/**
 * Javascript file for the page for searching for AI trainers.
 * @author Adrian Rebmann, Yannik Sprengart, Andreas Emrich
 */

import { getTrainersWithinRadius, getKITrainer, getMainEmphases, getIndustrySectors } from "../../../../api";

//Regular expression for the event dates.
const regex = new RegExp('([1-9]|0[1-9]|[12][0-9]|3[01])\s*([- /.])\\s*([1-9]|0[1-9]|1[012])\\s*\\2\\s*((19|20)?[0-9]{2})');


/**
 * Checks if an element exists in an array. 
 * @param {*} element - The element to be compared.
 * @param {*} array - The array to be compared.
 */
function existsElement(element, array) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].hash === element.hash) {
      return true
    }
  }
  return false;
};

export default {
  name: "KITrainerSearch",

  /**
   * The vue instance's data object.
   * @property {boolean} loading - Information is currently being processed.
   * @property {any[]} sectors - The available sectors.
   * @property {any[]} selectedsectors - The selected sectors.
   * @property {any[]} centers - The available centers.
   * @property {any[]} selectedcenters - The selected centers.
   * @property {any[]} skills - The available skills.
   * @property {any[]} selectedskills - The selected skills.
   * @property {any[]} trainers - All available AI trainers.
   * @property {any[]} searchresults - The results of the AI trainer search (filtered from this.trainers). 
   * @property {string[]} sortby - The sorting options for the search.
   * @property {any[]} selectedsortby - The selected sorting option for the search.
   * @property {string} plz - The postal code for the search.
   * @property {string} range - The range concerning the location of the trainers surrounding the postal code.
   * 
   * @property {string} msg - The platform's name. 
   */
  data() {
    return {
      loading: false,
      sectors: [],
      selectedsectors: [],
      centers: [],
      selectedcenters: [],
      skills: [],
      selectedskills: [],
      trainers: [],
      searchresults: [],
      sortby: ["Datum aufsteigend", "Datum absteigend"],
      selectedsortby: [],
      plz: "",
      range: "50",
      searchresults: [],
      msg: "WERNER",
    };
  },

  /**
   * Called after the instance has been mounted.
   */
  mounted() {
    this.loading = true;
    this.searchresults = []
    this.centers = [
    { full: "Mittelstand-Digital Zentrum Augsburg", short: "Augsburg" },
    { full: "Mittelstand-Digital Zentrum Bau", short: "Bau" },
    { full: "Mittelstand-Digital Zentrum Berlin", short: "Berlin" },
    { full: "Mittelstand-Digital Zentrum Bremen-Oldenburg", short: "Bremen-Oldenburg" },
    { full: "Mittelstand-Digital Zentrum Chemnitz", short: "Chemnitz" },
    { full: "Mittelstand-Digital Zentrum Darmstadt", short: "Darmstadt" },
    { full: "Mittelstand-Digital Zentrum Fokus Mensch", short: "Fokus Mensch" },
    { full: "Mittelstand-Digital Zentrum Franken", short: "Franken" },
    { full: "Mittelstand-Digital Zentrum Hamburg", short: "Hamburg" },
    { full: "Mittelstand-Digital Zentrum Handwerk", short: "Handwerk" },
    { full: "Mittelstand-Digital Zentrum Hannover", short: "Hannover" },
    { full: "Mittelstand-Digital Zentrum Ilmenau", short: "Ilmenau" },
    { full: "Mittelstand-Digital Zentrum Kaiserslautern", short: "Kaiserslautern" },
    { full: "Mittelstand-Digital Zentrum Klima.Neutral.Digital", short: "Klima.Neutral.Digital" },
    { full: "Mittelstand-Digital Zentrum Ländliche Regionen", short: "Ländliche Regionen" },
    { full: "Mittelstand-Digital Zentrum Leipzig-Halle", short: "Leipzig-Halle" },
    { full: "Mittelstand-Digital Zentrum Lingen.Münster.Osnabrück", short: "Lingen.Münster.Osnabrück" },
    { full: "Mittelstand-Digital Zentrum Magdeburg", short: "Magdeburg" },
    { full: "Mittelstand-Digital Zentrum Rheinland", short: "Rheinland" },
    { full: "Mittelstand-Digital Zentrum Rostock", short: "Rostock" },
    { full: "Mittelstand-Digital Zentrum Ruhr-OWL", short: "Ruhr-OWL" },
    { full: "Mittelstand-Digital Zentrum Saarbrücken", short: "Saarbrücken" },
    { full: "Mittelstand-Digital Zentrum Schleswig-Holstein", short: "Schleswig-Holstein" },
    { full: "Mittelstand-Digital Zentrum Smarte Kreisläufe", short: "Smarte Kreisläufe" },
    { full: "Mittelstand-Digital Zentrum Spreeland", short: "Spreeland" },
    { full: "Mittelstand-Digital Zentrum Tourismus", short: "Tourismus" },
    { full: "Mittelstand-Digital Zentrum WertNetzWerke", short: "WertNetzWerke" },
    { full: "Mittelstand-Digital Zentrum Zukunftskultur", short: "Zukunftskultur" },
  ]

    //Retrieve information about the AI trainer from the database.
    getKITrainer().then(res => {
      getMainEmphases().then(res2 => {
        this.skills = res2
        getIndustrySectors().then(res3 => {
          this.sectors = res3
          this.trainers = res;
          this.searchresults = res;
          this.loading = false;
        })
      })
    })
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Shows a placeholder image in case there is an error concern the trainer's image.
     * @param {*} item - The item where the picture is shown.
     */
    imageLoadingError(item) {
      item.image = 'no-avatar.jpg'
    },

    /**
     * Removes a sector from the selected sectors. 
     * @param {*} string - The name of the sector to be removed.
     */
    removeSector(string) {
      for (let i = 0; i < this.selectedsectors.length; i++) {
        if (this.selectedsectors[i] == (string))
          this.selectedsectors.splice(i, 1);
      }
    },

    /**
     * Removes a center from the selected centers. 
     * @param {*} string - The name of the center to be removed.
     */
    removeCenter(string) {
      for (let i = 0; i < this.selectedcenters.length; i++) {
        if (this.selectedcenters[i] == (string))
          this.selectedcenters.splice(i, 1);
      }
    },

    /**
     * Removes a skill from the selected skills. 
     * @param {*} string - The name of the skill to be removed.
     */
    removeSkill(string) {
      for (let i = 0; i < this.selectedskills.length; i++) {
        if (this.selectedskills[i] == (string))
          this.selectedskills.splice(i, 1);
      }
    },

    /**
     * Sorts all available AI trainers by the additional information entered by the user.
     */
    applyFilters() {
      this.loading = true
      let result = []
      let matches = true

      //If a valid postal code has been entered by the user
      if (this.plz != null && this.plz !== "" && this.plz.length == 5) {
        getTrainersWithinRadius(this.range, this.plz).then(res => {
          if (this.selectedcenters.length > 0 || this.selectedskills.length > 0 || this.selectedsectors.length > 0) {
            for (let j = 0; j < res.length; j++) {
              matches = true

              if (this.selectedcenters.length > 0 && !this.selectedcenters.includes(res[j].competence_center)) {
                matches = false
              }
              for( let i = 0; i < this.selectedskills.length; i++) {
                console.log(res[j].name)
                console.log(res[j].main_emphases.filter(x => x.name == this.selectedskills[i]))
                if(!(res[j].main_emphases.filter(x => x.name == this.selectedskills[i]).length > 0)) {
                  console.log("false")
                  matches = false
                }
              }
              for( let i = 0; i < this.selectedsectors.length; i++) {
                if(!(res[j].industry_sectors.filter(x => x.name == this.selectedsectors[i]).length > 0)) {
                  matches = false
                }
              }
              if(matches) {
                result.push(res[j])
              }
            }
          } else {
            result = res;
          }
          this.searchresults = result
          this.loading = false
        })
      } 
      
      // If either an invalid postal code or no postal code has been entered by the user
      else {
        //If either a center, a skill or a sector has been selected.
        if (this.selectedcenters.length > 0 || this.selectedskills.length > 0 || this.selectedsectors.length > 0) {
          for (let j = 0; j < this.trainers.length; j++) {
            matches = true

            if (this.selectedcenters.length > 0 && !this.selectedcenters.includes(this.trainers[j].competence_center)) {
              matches = false
            }
            for( let i = 0; i < this.selectedskills.length; i++) {
              if(!(this.trainers[j].main_emphases.filter(x => x.name == this.selectedskills[i]).length > 0)) {
                matches = false
              }
            }

            for( let i = 0; i < this.selectedsectors.length; i++) {
              if(!(this.trainers[j].industry_sectors.filter(x => x.name == this.selectedsectors[i]).length > 0)) {
                matches = false
              }
            }
            if(matches) {
              result.push(this.trainers[j])
            }
          }
        } 
        //If neither a center, a skill nor a sector has been selected.
        else {
          result = this.trainers;
        }
        this.searchresults = result
        this.loading = false
      }
    },

    /**
     * Resets the filters to the available AI trainers.
     */
    resetFilters() {
      this.searchresults = this.trainers;
      this.selectedcenters = [],
        this.selectedsectors = [],
        this.selectedskills = []
      this.plz = "",
        this.range = "50"
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/search/kitrainersearch/query/kitrainersearch.js